import React from 'react';
import Helmet from 'react-helmet'

import Favicon from "../../static/favicon.png"

function Metatags(props) {

    return (
        <Helmet
            title={props.title}
            meta={[
                { name: 'title', content: props.title },

                { name: 'description', content: props.description },

                { name: 'keywords', content: 'diseño web, diseño web españa, diseño web  sevilla ,sevilla diseño web , freelance diseño web sevilla, sevilla desarrollo web' },

                { 
                    property: 'og:type', 
                    content: 'website' 
                },

                {
                    property: 'og:url',
                    content: props.pathname ? props.url + props.pathname : props.url,
                },
    
                {
                    property: 'og:title',
                    content: props.title,
                },
                
                {
                    property: 'og:description',
                    content: props.description,
                },

                {
                    property: 'og:image',
                    content: props.thumbnail && props.thumbnail,
                },
                {
                    property: 'og:image:secure_url',
                    content: props.thumbnail && props.thumbnail,
                },

                
                {
                    property: 'og:image:width',
                    content: '1200',
                },

                {
                    property: 'og:image:height',
                    content: '630',
                },
                {
                    property: 'og:locale',
                    content: 'en',
                },

                { name: 'twitter:card', content: 'summary_large_image' },

                { name: 'twitter:title', content: props.title },

                {
                    name: 'twitter:description',
                    content: props.description,
                },
                {
                    name: 'twitter:image',
                    content: props.thumbnail && props.thumbnail,
                },

                { name: 'twitter:creator', content: '@jotafelix8' },
                { property: 'og:site_name', content: 'felixdigital.es' },

            ]}

            link={[
                { rel: 'shortcut icon', type: 'image/x-icon', href: `${Favicon}` },
            ]}
        >
            <html lang="es" />
        </Helmet>
    )
}

export default Metatags;